import React from 'react';
import Classes from "classnames";
import FormElementInput from "../../../core/gd-form/form-element/input/input";

type Props = {
    value?             : string;
    onChange           : callback
    clearSearchValue   : callback
    className?         : string
}

export default function Search(props: Props) {
    const searchClass = Classes("search-button", props.value ? "typing" : "")

    return (
        <div className={Classes("ui5-search", props.className)}>
            <div className="search-input">
                <FormElementInput
                    placeholder="Search..."
                    value={props.value}
                    onChange={(value: string) => props.onChange(value)}
                />
                <div className={searchClass} onClick={props.clearSearchValue}>
                    {props.value
                        ? <div className={Classes("i5-delete")}/>
                        : <div className={Classes("i5-search", "ui5-ico-14")}/>
                    }
                </div>
            </div>
        </div>
    );
}
